// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { auth, db } from '../firebase/config';
// import { signInWithEmailAndPassword } from 'firebase/auth';
// import { doc, getDoc, addDoc, collection, query, where, getDocs } from 'firebase/firestore';
// import { LogIn, Shield, AlertCircle, X, Check } from 'lucide-react';

// function EmployeeLogin() {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [initializing, setInitializing] = useState(true);
//   const [showForgotPassword, setShowForgotPassword] = useState(false);
//   const [forgotEmail, setForgotEmail] = useState('');
//   const [forgotError, setForgotError] = useState('');
//   const [forgotSuccess, setForgotSuccess] = useState('');
//   const navigate = useNavigate();

//   // Check if user is already logged in
//   useEffect(() => {
//     const unsubscribe = auth.onAuthStateChanged(async (user) => {
//       if (user) {
//         try {
//           const userDoc = await getDoc(doc(db, 'users', user.uid));
//           if (userDoc.exists()) {
//             const role = userDoc.data().role;
//             if (role === 'employee') {
//               navigate('/employee-dashboard', { replace: true });
//             } else if (role === 'admin') {
//               navigate('/admin-dashboard', { replace: true });
//             } else {
//               setError('Invalid user role.');
//               await auth.signOut();
//             }
//           } else {
//             setError('User data not found.');
//             await auth.signOut();
//           }
//         } catch (err) {
//           setError(`Error checking user: ${err.message}`);
//         }
//       }
//       setInitializing(false);
//     });
//     return () => unsubscribe();
//   }, [navigate]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError('');
//     setLoading(true);

//     try {
//       const userCredential = await signInWithEmailAndPassword(auth, email, password);
//       const user = userCredential.user;
//       const userDoc = await getDoc(doc(db, 'users', user.uid));
      
//       if (userDoc.exists()) {
//         const role = userDoc.data().role;
//         if (role === 'employee') {
//           navigate('/employee-dashboard', { replace: true });
//         } else if (role === 'admin') {
//           navigate('/admin-dashboard', { replace: true });
//         } else {
//           setError('Invalid user role.');
//           await auth.signOut();
//         }
//       } else {
//         setError('User data not found.');
//         await auth.signOut();
//       }
//     } catch (err) {
//       setError(`Error during login: ${err.message}`);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleForgotPassword = async (e) => {
//     e.preventDefault();
//     setForgotError('');
//     setForgotSuccess('');
//     setLoading(true);

//     try {
//       console.log('Starting forgot password process for email:', forgotEmail);
//       console.log('Step 1: Querying users collection...');
//       const usersRef = collection(db, 'users');
//       const q = query(usersRef, where('email', '==', forgotEmail));
//       const querySnapshot = await getDocs(q);
//       console.log('Query result:', querySnapshot.docs.map(doc => ({ id: doc.id, data: doc.data() })));

//       if (querySnapshot.empty) {
//         console.log('No user found with email:', forgotEmail);
//         setForgotError('No account found with this email.');
//         setLoading(false);
//         return;
//       }

//       const userDoc = querySnapshot.docs[0];
//       const userData = userDoc.data();
//       console.log('User found:', { id: userDoc.id, data: userData });

//       if (userData.role !== 'employee') {
//         console.log('User is not an employee, role:', userData.role);
//         setForgotError('Only employees can request a password change.');
//         setLoading(false);
//         return;
//       }

//       console.log('Step 2: Creating password request...');
//       const newRequest = {
//         userId: userDoc.id,
//         email: forgotEmail,
//         status: 'pending',
//         createdAt: new Date().toISOString(),
//       };
//       console.log('Password request data:', newRequest);
//       await addDoc(collection(db, 'passwordRequests'), newRequest);
//       console.log('Password request created successfully');

//       setForgotSuccess('Password change request submitted. You will be notified soon.');
//       setTimeout(() => {
//         setShowForgotPassword(false);
//         setForgotEmail('');
//         setForgotSuccess('');
//       }, 3000);
//     } catch (err) {
//       console.error('Error in handleForgotPassword:', err);
//       setForgotError(`Error submitting request: ${err.message}`);
//       if (err.code === 'permission-denied') {
//         setForgotError('Permission denied. Ensure Firestore rules allow this operation.');
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (initializing) {
//     return (
//       <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
//           <p className="text-gray-600">Checking authentication...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
//       <div className="w-full max-w-md">
//         <div className="text-center mb-8">
//           <div className="mx-auto w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-4">
//             <Shield className="w-8 h-8 text-white" />
//           </div>
//           <h1 className="text-3xl font-bold text-gray-800 mb-2">Employee Portal</h1>
//           <p className="text-gray-600">Sign in to your employee account</p>
//         </div>

//         <div className="bg-white rounded-lg shadow-lg p-8">
//           {error && (
//             <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg flex items-center">
//               <AlertCircle className="w-5 h-5 text-red-500 mr-2" />
//               <span className="text-red-700 flex-1">{error}</span>
//               <button
//                 onClick={() => setError('')}
//                 className="text-red-500 hover:text-red-700 ml-2"
//               >
//                 <X className="w-4 h-4" />
//               </button>
//             </div>
//           )}

//           <form onSubmit={handleSubmit}>
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Email Address
//               </label>
//               <input
//                 type="email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
//                 placeholder="employee@company.com"
//                 required
//                 disabled={loading}
//               />
//             </div>

//             <div className="mb-6">
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Password
//               </label>
//               <input
//                 type="password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
//                 placeholder="••••••••"
//                 required
//                 disabled={loading}
//               />
//             </div>

//             <button
//               type="submit"
//               disabled={loading}
//               className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
//             >
//               {loading ? (
//                 <div className="flex items-center">
//                   <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
//                   Signing in...
//                 </div>
//               ) : (
//                 <div className="flex items-center">
//                   <LogIn className="w-5 h-5 mr-2" />
//                   Sign In
//                 </div>
//               )}
//             </button>
//           </form>



//           <div className="mt-6 text-center">
//             <p className="text-sm text-gray-600">
//               Need help? Contact your system administrator
//             </p>
//           </div>
//         </div>

//         {/* Forgot Password Dialog */}
//         {showForgotPassword && (
//           <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//             <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
//               <div className="flex justify-between items-center mb-4">
//                 <h3 className="text-lg font-semibold text-gray-800">Request Password Change</h3>
//                 <button
//                   onClick={() => setShowForgotPassword(false)}
//                   className="text-gray-500 hover:text-gray-700"
//                 >
//                   <X className="w-5 h-5" />
//                 </button>
//               </div>

//               {forgotError && (
//                 <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg flex items-center">
//                   <AlertCircle className="w-4 h-4 text-red-500 mr-2" />
//                   <span className="text-red-700 text-sm">{forgotError}</span>
//                 </div>
//               )}

//               {forgotSuccess && (
//                 <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg flex items-center">
//                   <Check className="w-4 h-4 text-green-500 mr-2" />
//                   <span className="text-green-700 text-sm">{forgotSuccess}</span>
//                 </div>
//               )}

//               <form onSubmit={handleForgotPassword}>
//                 <div className="mb-4">
//                   <label className="block text-sm font-medium text-gray-700 mb-2">
//                     Email Address
//                   </label>
//                   <input
//                     type="email"
//                     value={forgotEmail}
//                     onChange={(e) => setForgotEmail(e.target.value)}
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
//                     placeholder="employee@company.com"
//                     required
//                     disabled={loading}
//                   />
//                 </div>

//                 <div className="flex justify-end space-x-3">
//                   <button
//                     type="button"
//                     onClick={() => setShowForgotPassword(false)}
//                     className="bg-gray-100 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-200 transition-colors"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     disabled={loading}
//                     className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//                   >
//                     {loading ? 'Submitting...' : 'Submit Request'}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default EmployeeLogin;



import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../firebase/config';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { doc, getDoc, addDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { LogIn, Shield, AlertCircle, X, Check } from 'lucide-react';

function EmployeeLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [initializing, setInitializing] = useState(true);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotError, setForgotError] = useState('');
  const [forgotSuccess, setForgotSuccess] = useState('');
  const navigate = useNavigate();

  // Check if user is already logged in
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        try {
          const userDoc = await getDoc(doc(db, 'users', user.uid));
          if (userDoc.exists()) {
            const role = userDoc.data().role;
            if (role === 'employee') {
              navigate('/employee-dashboard', { replace: true });
            } else if (role === 'admin') {
              navigate('/admin-dashboard', { replace: true });
            } else {
              setError('Invalid user role.');
              await auth.signOut();
            }
          } else {
            setError('User data not found.');
            await auth.signOut();
          }
        } catch (err) {
          setError('Unable to verify user. Please try again.');
        }
      }
      setInitializing(false);
    });
    return () => unsubscribe();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      const userDoc = await getDoc(doc(db, 'users', user.uid));
      
      if (userDoc.exists()) {
        const role = userDoc.data().role;
        if (role === 'employee') {
          navigate('/employee-dashboard', { replace: true });
        } else if (role === 'admin') {
          navigate('/admin-dashboard', { replace: true });
        } else {
          setError('Invalid user role.');
          await auth.signOut();
        }
      } else {
        setError('User data not found.');
        await auth.signOut();
      }
    } catch (err) {
      let errorMessage = 'Unable to sign in. Please try again.';
      if (err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password') {
        errorMessage = 'Invalid email or password.';
      } else if (err.code === 'auth/too-many-requests') {
        errorMessage = 'Too many attempts. Please try again later.';
      }
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setForgotError('');
    setForgotSuccess('');
    setLoading(true);

    try {
      console.log('Starting forgot password process for email:', forgotEmail);
      console.log('Step 1: Querying users collection...');
      const usersRef = collection(db, 'users');
      const q = query(usersRef, where('email', '==', forgotEmail));
      const querySnapshot = await getDocs(q);
      console.log('Query result:', querySnapshot.docs.map(doc => ({ id: doc.id, data: doc.data() })));

      if (querySnapshot.empty) {
        console.log('No user found with email:', forgotEmail);
        setForgotError('No account found with this email.');
        setLoading(false);
        return;
      }

      const userDoc = querySnapshot.docs[0];
      const userData = userDoc.data();
      console.log('User found:', { id: userDoc.id, data: userData });

      if (userData.role !== 'employee') {
        console.log('User is not an employee, role:', userData.role);
        setForgotError('Only employees can request a password change.');
        setLoading(false);
        return;
      }

      console.log('Step 2: Creating password request...');
      const newRequest = {
        userId: userDoc.id,
        email: forgotEmail,
        status: 'pending',
        createdAt: new Date().toISOString(),
      };
      console.log('Password request data:', newRequest);
      await addDoc(collection(db, 'passwordRequests'), newRequest);
      console.log('Password request created successfully');

      setForgotSuccess('Password change request submitted. You will be notified soon.');
      setTimeout(() => {
        setShowForgotPassword(false);
        setForgotEmail('');
        setForgotSuccess('');
      }, 3000);
    } catch (err) {
      console.error('Error in handleForgotPassword:', err);
      setForgotError('Unable to submit password change request. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (initializing) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Checking authentication...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="mx-auto w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-4">
            <Shield className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-gray-800 mb-2">Employee Portal</h1>
          <p className="text-gray-600">Sign in to your employee account</p>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8">
          {error && (
            <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg flex items-center">
              <AlertCircle className="w-5 h-5 text-red-500 mr-2" />
              <span className="text-red-700 flex-1">{error}</span>
              <button
                onClick={() => setError('')}
                className="text-red-500 hover:text-red-700 ml-2"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Email Address
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                placeholder="employee@company.com"
                required
                disabled={loading}
              />
            </div>

            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                placeholder="••••••••"
                required
                disabled={loading}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
            >
              {loading ? (
                <div className="flex items-center">
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                  Signing in...
                </div>
              ) : (
                <div className="flex items-center">
                  <LogIn className="w-5 h-5 mr-2" />
                  Sign In
                </div>
              )}
            </button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-sm text-gray-600">
              Need help? Contact your system administrator
            </p>
          </div>
        </div>

        {/* Forgot Password Dialog */}
        {showForgotPassword && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold text-gray-800">Request Password Change</h3>
                <button
                  onClick={() => setShowForgotPassword(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>

              {forgotError && (
                <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg flex items-center">
                  <AlertCircle className="w-4 h-4 text-red-500 mr-2" />
                  <span className="text-red-700 text-sm">{forgotError}</span>
                </div>
              )}

              {forgotSuccess && (
                <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg flex items-center">
                  <Check className="w-4 h-4 text-green-500 mr-2" />
                  <span className="text-green-700 text-sm">{forgotSuccess}</span>
                </div>
              )}

              <form onSubmit={handleForgotPassword}>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Email Address
                  </label>
                  <input
                    type="email"
                    value={forgotEmail}
                    onChange={(e) => setForgotEmail(e.target.value)}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                    placeholder="employee@company.com"
                    required
                    disabled={loading}
                  />
                </div>

                <div className="flex justify-end space-x-3">
                  <button
                    type="button"
                    onClick={() => setShowForgotPassword(false)}
                    className="bg-gray-100 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-200 transition-colors"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={loading}
                    className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {loading ? 'Submitting...' : 'Submit Request'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default EmployeeLogin;